<template>
  <v-layout wrap>
    <v-flex md3 xs12 v-if="selectedState && selectedState.icon">
      <v-btn
        :color="hover && goBackState ? 'red' : color(selectedState)"
        class="right-triangle ml-1 my-1 mr-2"
        fab
        depressed
        dark
        small
        @mouseover="hover = true"
        @mouseleave="hover = false"
        @click="goToGoBackState()"
      >
        <v-icon
          v-if="selectedState.icon"
          small
        >
          {{ hover && goBackState ? 'fa-times' : selectedState.icon }}
        </v-icon>
      </v-btn>
      <b>{{ selectedState['stateNameText_' + $store.state.language] || selectedState['stateNameText_en'] }}</b>
    </v-flex>
    <v-flex md2 xs12 v-if="id !== '0' && selectedState && nextStates && nextStates[0]">
      <v-btn
        color="grey"
        class="right-triangle ml-1 my-1 mr-2"
        fab
        text
        depressed
        dark
        small
        @click="changeToObjectState(nextStates[0])"
      >
        <v-icon
          large
        >
          fa-angle-right
        </v-icon>
      </v-btn>
    </v-flex>
    <v-flex md7 xs12 v-if="id !== '0'">
      <div
        v-for="(objectState, index) in nextStates"
        style="position: relative; float:left;"
      >
        <v-btn
          :key="index"
          :color="color(objectState)"
          class="right-triangle ml-1 my-1"
          depressed
          dark
          @click="changeToObjectState(objectState)"
        >
          <v-icon
            v-if="objectState.icon"
            small
            class="mr-2"
          >
            {{ objectState.icon }}
          </v-icon>
          {{ objectState['stateActionText_' + $store.state.language] || objectState['stateActionText_en'] }}

        </v-btn>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import sharedComputed from './../../computed'
import sharedMethods from './../../methods'
import formElementProps from './formElementProps'

export default {
  name: 'FormObjectState',

  props: {
    ...formElementProps,

    moduleName: {
      type: String,
      default: null
    },

    value: {
      type: String,
      default: null
    },

    id: {
      type: String,
      default: null
    },

    field: {
      type: Object,
      default: () => {
        return {}
      }
    },

    changeStateForField: {
      type: Function,
      default: () => {
        return {}
      }
    }
  },

  data: () => {
    return {
      hover: false
    }
  },

  created () {
    if (this.id === '0') {
      if (this.selectedState) {
        this.changeToObjectState(this.selectedState)
      }
    }
    // console.log('this.field', this.field)
  },

  computed: {
    ...sharedComputed,

    nextStates () {
      if (!this.$store.getters.objectStatesByModule ||
        !this.$store.getters.objectStatesByModule[this.moduleName]
      ) {
        return []
      }
      return this.$store.getters.objectStatesByModule[this.moduleName].filter(objectState => {
        return this.selectedState && this.selectedState.nextStateIds && this.selectedState.nextStateIds.includes(objectState.id)
        })
    },

    selectedState () {
      let selectedStateArr = []
      if (this.value) {
        selectedStateArr = this.$store.getters.objectStatesByModule[this.moduleName].filter(state => state.id === this.value)
      }
      if (!selectedStateArr || selectedStateArr.length === 0) {
        selectedStateArr = this.$store.getters.objectStatesByModule[this.moduleName]
      }
      if (selectedStateArr && selectedStateArr[0]) {
        selectedStateArr[0].nextStateIds = (selectedStateArr[0].nextStates && selectedStateArr[0].nextStates.map(nextState => nextState.id )) || []
      } else if (this.$store.getters.objectStatesByModule[this.moduleName]) {
        selectedStateArr = [this.$store.getters.objectStatesByModule[this.moduleName][0]]
      }
      return (selectedStateArr && selectedStateArr[0]) || null
    },

    goBackState () {
      return (this.selectedState && this.selectedState.goBackState) || null
    }
  },

  methods: {
    ...sharedMethods,

    color (objectState) {
      return objectState.color || 'grey'
    },

    changeToObjectState (objectState) {
      this.changeStateForField(this.field, objectState)
    },

    goToGoBackState () {
      if (this.selectedState && this.goBackState) {
        this.changeToObjectState(this.goBackState)
      }
    }
  }
}
</script>
